import { FormSteps } from "@/types/data";
import { useState } from "react";

function useFormSteps() {
  const [formStep, setFormStep] = useState<FormSteps>(() => {
    const isDesktop = window.matchMedia("(min-width: 48em)").matches;
    return isDesktop ? FormSteps.Photo : FormSteps.LiveCamera;
  });

  return { formStep, setFormStep };
}

export default useFormSteps;
